module.exports = __webpack_public_path__ + "img/lou_lim_ioc_gardens.f001d346.jpg";